/**
 * API client with a 5-minute client-side cache, as required by the performance
 * contract. Never hardcodes a URL: everything comes from REACT_APP_BACKEND_URL.
 */
import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE, withCredentials: true, timeout: 20000 });

/** Absolute URL for a direct link or download (never a hardcoded host). */
export const apiUrl = (path) => `${BASE}${path}`;

const CACHE_TTL = 5 * 60 * 1000;
const cache = new Map();

function keyFor(path, params) {
  return `${path}?${new URLSearchParams(params || {}).toString()}`;
}

export async function getCached(path, params) {
  const key = keyFor(path, params);
  const hit = cache.get(key);
  if (hit && Date.now() - hit.at < CACHE_TTL) return hit.data;
  const { data } = await api.get(path, { params });
  cache.set(key, { at: Date.now(), data });
  return data;
}

export function invalidate(prefix) {
  Array.from(cache.keys()).forEach((key) => {
    if (!prefix || key.startsWith(prefix)) cache.delete(key);
  });
}

/** Disclosure search. Never cached: the query changes on every keystroke. */
export async function search(q, params = {}) {
  const { data } = await api.get('/search', { params: { q, ...params } });
  return data;
}

export default api;
